export default __webpack_public_path__ + "static/media/face_1_22.1bcc8d45.png";